import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {AchooTextFieldComponent} from '../achoo-text-field/achoo-text-field.component';
import {MentionResponse} from '../../../models/mention';
import {StringUtils} from '../../utils/string.utils';
import {CampaignService} from '../../services/campaign/campaign.service';
import {MentionService} from '../../services/mention/mention.service';
import {Observable} from 'rxjs/Observable';
import {ModalService} from '../../services/modal/modal.service';
import {AchooPopupComponent} from '../achoo-popup/achoo-popup.component';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import {ValidationHandlerService} from '../validation-handler.service';
import {TranslateService} from '@ngx-translate/core';
import {EventTrackerService, Page, UserActionType, ActivePages, ActionSource} from '../../services/event-tracker/event-tracker.service';
import { ActivePage } from '../../../models/event-tracker';
import {UserService} from '../../services/user.service';

@Component({
  selector: 'achoo-keywork-input-field',
  templateUrl: './achoo-keywork-input-field.component.html',
  styleUrls: ['./achoo-keywork-input-field.component.scss']
})
export class AchooKeyworkInputFieldComponent implements OnInit {
  @ViewChild('mentionInput')
  public mentionInput: AchooTextFieldComponent;
  @ViewChild('confirmRemoveMentionDialog')
  confirmRemoveMentionDialog: AchooPopupComponent;
  @ViewChild('ErrorWhenAddingNewMention')
  errorWhenAddingNewMention: AchooPopupComponent;
  @Input()
  public label: string;
  @Input()
  public name: string;
  @Input()
  public readOnly = false;
  @Input()
  public mentions: MentionResponse[] = [];
  @Input()
  public countries: any;
  @Input()
  public enableCountry: boolean;
  @Input()
  public checkMentionExisting = true;
  @Input()
  public activePage: ActivePage;
  @Input()
  public actionSource: ActionSource;
  @Input()
  public isEditProjectFragment = false;

  @Output() beforeProgressingMention = new EventEmitter<any>();
  @Output() afterProgressingMention = new EventEmitter<any>();

  public currentInputMention = '';
  public currentDeleteMention: MentionResponse;
  private currentDeleteMentionIndex = -1;
  public countryList: [any];
  public errorMentions: string[] = [];

  constructor(private campaignService: CampaignService,
              private mentionService: MentionService,
              private referenceDataService: ReferenceDataService,
              protected validateErrorHandler: ValidationHandlerService,
              private userService: UserService,
              private modalService: ModalService,
              private translate: TranslateService) { }

  ngOnInit() {
    if (!this.mentions) {
      this.mentions = [];
    }
    // load list supported countries
    if (this.enableCountry === true) {
      const referenceData = this.referenceDataService.referenceData;
      this.countryList = referenceData.countries.map((country) => ({
          id: country.id,
          name: country.name
        })
      );
    }
  }

  get mentionKeywords() {
    return this.mentions ? this.mentions.map(x => x.keyword) : [];
  }

  get processingMentionKeywords() {
    return this.mentions ? this.mentions.filter(m => m.id === -1).map(x => x.keyword) : [];
  }

  mentionInputKeyDown(evt: KeyboardEvent) {
    // User input something - not hit ENTER
    if (!evt || evt.keyCode !== 13) {
      return;
    }
    // User hit ENTER
    if (this.currentInputMention && StringUtils.trim(this.currentInputMention) !== '') {
      const mention = this.campaignService.parseMentions(this.currentInputMention);
      mention.language.push(0); // Todo: currently just use global language as temporaty

      if (this.isExistingMention(mention.keyword)) {
        // clear current input
        this.currentInputMention = '';
        // do nothing
        return;
      }

      // Update UI immediately.
      // Replace if add succeed
      // Remove if error catched
      if (!this.checkMentionExisting) {
        this.mentions.push({
          id: -1,
          keyword: mention.keyword
        });
        this.currentInputMention = '';
      }

      if (!this.activePage) {
        this.activePage = new ActivePage();
      }

      const activePage: ActivePage = {
        type: this.activePage.type,
        name: this.activePage.name,
        id: this.activePage.id
      };

      const actionSource = this.actionSource;

      this.mentionService.processNewMention(mention, this.beforeProcessingNewMention.bind(this), this.afterProcessingNewMention.bind(this), activePage, actionSource);
    }
  }

  private beforeProcessingNewMention(mention) {
    this.beforeProgressingMention.emit(mention);
  }

  private afterProcessingNewMention(data) {
    // if mention is not existed
    if (!data.alreadyExisted) {
      // has error during processing
      if (data.hasError) {
        // remove the processing mention
        const processingMention = this.mentions.find(men => men.keyword === data.errorMention.keyword);
        // mark error mention with id = -2
        processingMention.id = -2;
        this.errorMentions.push(processingMention.keyword);
        this.modalService.open(this.errorWhenAddingNewMention, undefined, true);
      } else {
        setTimeout(() => {
          this.mentionInput.setFocus();
        }, 0);
        const selectdIndex = this.mentions.findIndex((m) => m.keyword === data.newMention.keyword);
        this.mentions.splice(selectdIndex, 1, data.newMention); // Replace
      }
    } else {
      // if mention is existed
      if (this.checkMentionExisting) {
        // if existing and need validate. show error message
        this.validateErrorHandler.updateErrors([{
          name: this.name,
          message: this.translate.instant('campaigns.mention_already_existed')
        }]);
        this.validateErrorHandler.shouldDisplayErrors(true);
      } else {
        const selectedMention = this.mentions.find(men => StringUtils.trim(data.newMention.keyword.toLowerCase()) === StringUtils.trim(men.keyword.toLowerCase()));
        if (selectedMention) {
          selectedMention.id = data.newMention.id;
        }
      }
    }
    // after processing all mentions
    this.validateListMentionAfterProcessing(data.newMention);
  }

  /**
   * when all mention is valid and no mention is processing.
   * Trigger callback afterProcessing
   * @param processionMention
   */
  private validateListMentionAfterProcessing(processionMention) {
    // after processing all mentions
    const inProgressMentions = this.mentions.filter(m => m.id === -1);
    if (inProgressMentions.length === 0 && this.errorMentions.length === 0) {
      this.afterProgressingMention.emit(processionMention);
    }
  }

  private isExistingMention(keyword) {
    if (!this.mentions) {
      return false;
    }

    return this.mentions.findIndex(mention => mention.keyword.toLowerCase() === keyword.toLowerCase()) >= 0;
  }

  closeConfirmRemoveMentionMessage() {
    this.modalService.close();
  }

  confirmationBeforeDeleteMention(index: number) {
    const currentMention = this.mentions[index];
    if (!currentMention) {
      return;
    }
    if (!this.isEditProjectFragment) {
      this.modalService.openInCenter(this.confirmRemoveMentionDialog);
    }
    this.currentDeleteMention = currentMention;
    this.currentDeleteMentionIndex = index;
    if (this.isEditProjectFragment) {
      this.onDeleteMention();
    }
  }

  onDeleteMention() {
    if (!this.currentDeleteMention) {
      this.modalService.close();
      return;
    }
    const deleteItem = this.mentions[this.currentDeleteMentionIndex];
    // remove deleted item in error mention list
    this.errorMentions = this.errorMentions.filter(em => em !== deleteItem.keyword);
    // remove item in mention list
    this.mentions.splice(this.currentDeleteMentionIndex, 1);
    // validate list mention
    this.validateListMentionAfterProcessing(deleteItem);
    // close modal
    this.modalService.close();
    this.currentDeleteMention = null;
    this.currentDeleteMentionIndex = -1;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/achoo-keywork-input-field/achoo-keywork-input-field.component.ts